import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { ReactComponent as MapMarkerSmall } from 'images/event-search/map-marker-small.svg'
import { metersToMiles } from '../utils/distance'

const useStyles = makeStyles(theme => ({
  distance: {
    alignItems: 'center',
    backgroundColor: theme.palette.card.distance.background,
    borderRadius: 8,
    color: theme.palette.primary.main,
    display: 'flex',
    alignSelf: 'flex-start',
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),

    '& > p': {
      fontSize: '14px',
      fontWeight: 'bold',
    },

    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1.5),
    },
  },

  mapMarker: {
    height: theme.spacing(2.5),
    marginRight: theme.spacing(0.5),
  },
}))

export default function Distance({ hit }) {
  const classes = useStyles()
  const distance = metersToMiles(hit._rankingInfo.geoDistance).toFixed(1)

  return (
    <div className={classes.distance}>
      <div className={classes.mapMarker}>
        <MapMarkerSmall />
      </div>

      <Typography variant="body1">{distance} MI</Typography>
    </div>
  )
}
